<template>
  <section id="hospital-primary-information" class="case-creation">
    <div
      class="case-creation__step case-creation__patient-information"
      v-loading="disableSubmitButton"
    >
      <div
        class="case-creation__card"
        v-if="getSingleHospital && status == 'view'"
      >
        <div class="vue-data">
          <div class="case-creation__body pb-0">
            <div class="hospital-action-buttons">
              <el-button
                class="hospital-edit-btn"
                @click="changeStatus"
                :disabled="!isLabdaqOnlyEditor"
                v-if="hasPermission('hospitals', 'add') || isLabdaqOnlyEditor"
              >
                <span class="edit-icon">
                  <img
                    src="@/assets/images/icons/edit-case-information.svg"
                    alt=""
                  />
                  EDIT
                </span>
              </el-button>
              <el-button class="audit-btn" @click="viewHospitalAudit">
                Audit
              </el-button>
            </div>

            <el-row :gutter="20">
              <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Ordering Facility Name</h4>
                  <p class="value">{{ this.hospitalInfo.name }}</p>
                </div>
              </el-col>

              <el-col :xl="3" :lg="2" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Code</h4>

                  <p class="value">{{ this.hospitalInfo.code }}</p>
                </div>
              </el-col>

              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Phone Number</h4>

                  <p class="value">{{ this.hospitalInfo.phone }}</p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Fax</h4>

                  <p class="value">
                    {{ this.hospitalInfo.fax ? this.hospitalInfo.fax : "--" }}
                  </p>
                </div>
              </el-col>

              <el-col :xl="3" :lg="5" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Email</h4>

                  <p class="value">
                    {{
                      this.hospitalInfo.email ? this.hospitalInfo.email : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="5" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Account Number</h4>

                  <p class="value">
                    {{
                      this.hospitalInfo.account_number ? this.hospitalInfo.account_number : "--"
                    }}
                  </p>
                </div>
              </el-col>

              <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Address Line 1</h4>

                  <p class="value">
                    {{
                      this.hospitalInfo.address_line_1
                        ? this.hospitalInfo.address_line_1
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>

              <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Address Line 2</h4>

                  <p class="value">
                    {{
                      this.hospitalInfo.address_line_2
                        ? this.hospitalInfo.address_line_2
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="2" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Zip</h4>

                  <p class="value">
                    {{ this.hospitalInfo.zip }}
                  </p>
                </div>
              </el-col>

              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">State</h4>

                  <p class="value">
                    {{ this.hospitalInfo.state }}
                  </p>
                </div>
              </el-col>

              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">City</h4>

                  <p class="value">
                    {{ this.hospitalInfo.city }}
                  </p>
                </div>
              </el-col>

              <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">NPI</h4>

                  <p class="value">
                    {{ this.hospitalInfo.npi ? this.hospitalInfo.npi : "--" }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                <div
                  class="input-value view-cases"
                  v-if="
                    this.hospitalInfo &&
                    this.hospitalInfo.facility_marketer &&
                    this.hospitalInfo.facility_marketer.length
                  "
                >
                  <h4 class="name">Sales Rep</h4>
                  <ul>
                    <li
                      v-for="(Manager, index) of this.hospitalInfo
                        .facility_marketer"
                      :key="index"
                    >
                      {{ Manager.first_name + "" + Manager.last_name || "--" }}
                    </li>
                  </ul>
                </div>
                <div class="input-value view-cases" v-else>
                  <h4 class="name">Sales Rep</h4>
                  <p>--</p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                <div
                  class="input-value view-cases"
                  v-if="
                    this.hospitalInfo &&
                    this.hospitalInfo.account_managers &&
                    this.hospitalInfo.account_managers.length
                  "
                >
                  <h4 class="name">Account Manager</h4>
                  <ul>
                    <li
                      v-for="(Manager, index) of this.hospitalInfo
                        .account_managers"
                      :key="index"
                    >
                      {{ Manager.first_name + "" + Manager.last_name || "--" }}
                    </li>
                  </ul>
                </div>
                <div class="input-value view-cases" v-else>
                  <h4 class="name">Account Manager</h4>
                  <p>--</p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="3" :md="8" :sm="12" :xs="12">
                <div class="input-value">
                  <h4 class="name">Labdaq Code</h4>
                  <p class="value error-break">
                    {{
                      this.hospitalInfo.labdaq_code
                        ? this.hospitalInfo.labdaq_code
                        : "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="10" :lg="10" :md="14" :sm="14" :xs="14">
                <div class="input-value">
                  <h4 class="name">Account Setup Form</h4>
                  <div class="consent_main">
                    <div
                      class="consent_form"
                      v-if="
                        hospitalInfo &&
                        hospitalInfo.attachments &&
                        hospitalInfo.attachments.length
                      "
                    >
                      <div
                        v-for="(doc, index) of hospitalInfo.attachments"
                        :key="index"
                        class="attachment-uploaded"
                      >
                        <div class="content_block">
                          <p class="value">
                            {{
                              doc.metadata && doc.metadata.original_name
                                ? doc.metadata.original_name
                                : ""
                            }}
                          </p>
                        </div>
                        <div class="consent_btn">
                          <el-button
                            @click="downloadAttachment(doc)"
                            class="cursor"
                            title="VIEW"
                          >
                            <img
                              class="action-active"
                              src="@/assets/images/icons/actions/view-icon.svg"
                              alt="icon"
                            />
                          </el-button>
                          <el-button
                            @click="removeFacilityConsentForm(doc.path)"
                            class="cursor"
                            title="REMOVE"
                            disabled
                          >
                            <img
                              class="action-active"
                              src="@/assets/images/icons/actions/delete-active.svg"
                              alt="icon"
                            />
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <div>
                      <el-upload
                        name="logo"
                        action
                        :on-change="uploadFile"
                        :show-file-list="false"
                        :auto-upload="false"
                        accept=".pdf"
                        disabled
                      >
                        <el-button
                          class="btn radius-button round-button"
                          disabled
                        >
                          <span>
                            <img
                              src="@/assets/images/icons/attachment-icon-v2.svg"
                              alt=""
                            /> </span
                          >UPLOAD ACCOUNT SETUP FORM</el-button
                        >
                      </el-upload>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="case-creation__heading border-top">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-patient-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">CONTACT INFORMATION</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <!-- Critical Reporting Point of Contact -->
            <div class="contact-section mb-20">
              <h4 class="contact-section-title">Critical Reporting Point of Contact</h4>
              <el-row :gutter="20">
                <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Name</h4>
                    <p class="value">
                      {{
                        this.hospitalInfo.contact_poc &&
                        this.hospitalInfo.contact_poc.name
                          ? this.hospitalInfo.contact_poc.name
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Email</h4>
                    <p class="value">
                      {{
                        this.hospitalInfo.contact_poc &&
                        this.hospitalInfo.contact_poc.email
                          ? this.hospitalInfo.contact_poc.email
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Phone Number</h4>
                    <p class="value">
                      {{
                        this.hospitalInfo.contact_poc &&
                        this.hospitalInfo.contact_poc.phone_number
                          ? this.hospitalInfo.contact_poc.phone_number
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
              </el-row>
            </div>

            <!-- Rejections and Recollections Point of Contact -->
            <div class="contact-section">
              <h4 class="contact-section-title">Rejections and Recollections Point of Contact</h4>
              <el-row :gutter="20">
                <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Name</h4>
                    <p class="value">
                      {{
                        this.hospitalInfo.rejection_poc &&
                        this.hospitalInfo.rejection_poc.name
                          ? this.hospitalInfo.rejection_poc.name
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Email</h4>
                    <p class="value">
                      {{
                        this.hospitalInfo.rejection_poc &&
                        this.hospitalInfo.rejection_poc.email
                          ? this.hospitalInfo.rejection_poc.email
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                  <div class="input-value">
                    <h4 class="name">Phone Number</h4>
                    <p class="value">
                      {{
                        this.hospitalInfo.rejection_poc &&
                        this.hospitalInfo.rejection_poc.phone_number
                          ? this.hospitalInfo.rejection_poc.phone_number
                          : "--"
                      }}
                    </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="case-creation__heading border-top">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-patient-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Ordering Facility Settings</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="input-value">
                  <h4 class="name">Auto Fax</h4>
                  <p>{{ settingsInfo.auto_fax ? "Yes" : "No" }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="input-value">
                  <h4 class="name">Email Notification</h4>
                  <p>{{ settingsInfo.email_notifications ? "Yes" : "No" }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="input-value">
                  <h4 class="name">Requires Inhouse Phlebotomist</h4>
                  <p>
                    {{ settingsInfo.requires_inhouse_phlebotomist ? "Yes" : "No" }}
                  </p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="input-value">
                  <h4 class="name">Daily Statistics</h4>
                  <p>{{ settingsInfo.daily_statistics ? "Yes" : "No" }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="input-value">
                  <h4 class="name">Is Labdaq</h4>
                  <p>{{ settingsInfo.is_labdaq ? "Yes" : "No" }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="input-value">
                  <h4 class="name">Uni Direction EMR</h4>
                  <p>
                    {{ settingsInfo.emr_unidirectional_status ? "Yes" : "No" }}
                  </p>
                </div>
              </el-col>
              <el-col :span="6" v-if="hasPermission('notify_rejection', 'add')">
                <div class="input-value">
                  <h4 class="name">Restrict Insurance</h4>
                  <p>
                    {{ settingsInfo.restrict_insurance ? "Yes" : "No" }}
                  </p>
                </div>
              </el-col>
              <el-col :span="6" v-if="hasPermission('notify_rejection', 'add')">
                <div class="input-value">
                  <h4 class="name">Notify Rejections</h4>
                  <p>
                    {{ settingsInfo.notify_rejections ? "Yes" : "No" }}
                  </p>
                </div>
              </el-col>
              <el-col :span="6" v-if="hasPermission('notify_rejection', 'add')">
                <div class="input-value">
                  <h4 class="name">Release</h4>
                  <p>
                    {{ settingsInfo.release_note ? "Yes" : "No" }}
                  </p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="input-value">
                  <h4 class="name">Sample Collection Type</h4>
                  <p>{{ formatCollectionType(settingsInfo.sample_collection_type) }}</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="input-value">
                  <h4 class="name">Daily Sample Pickup</h4>
                  <p>{{ settingsInfo.is_daily_sample_pickup ? "Yes" : "No" }}</p>
                </div>
              </el-col>
              <template v-if="settingsInfo.is_daily_sample_pickup">
                <el-col :span="6">
                  <div class="input-value">
                    <h4 class="name">Pickup Time</h4>
                    <p>{{ settingsInfo.pickup_time || "--" }}</p>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="input-value">
                    <h4 class="name">Pickup Days</h4>
                    <p>{{ (settingsInfo.pickup_days || []).join(", ") || "--" }}</p>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="input-value">
                    <h4 class="name">Pickup Address</h4>
                    <p>{{ settingsInfo.pickup_address || "--" }}</p>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="input-value">
                    <h4 class="name">Pickup Zip</h4>
                    <p>{{ settingsInfo.pickup_zip || "--" }}</p>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="input-value">
                    <h4 class="name">Pickup City</h4>
                    <p>{{ settingsInfo.pickup_city || "--" }}</p>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="input-value">
                    <h4 class="name">Pickup State</h4>
                    <p>{{ settingsInfo.pickup_state || "--" }}</p>
                  </div>
                </el-col>
              </template>
            </el-row>
          </div>
          <div class="case-creation__heading border-top">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-patient-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Patient Report Settings</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="input-value" v-if="patientSettingsInfo">
                  <h4 class="name">Send Finalized Report To Patient</h4>
                  <p>
                    {{
                      patientSettingsInfo.send_finalized_report_to_patient
                        ? "Yes"
                        : "No"
                    }}
                  </p>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="5">
                <div
                  class="input-value"
                  v-if="
                    patientSettingsInfo &&
                    patientSettingsInfo.email_sending_data
                  "
                >
                  <h4 class="name">Email Sending</h4>
                  <p>
                    {{
                      patientSettingsInfo.email_sending_data.status
                        ? "Yes"
                        : "No"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :span="5">
                <div
                  class="input-value"
                  v-if="
                    patientSettingsInfo &&
                    patientSettingsInfo.email_sending_data
                  "
                >
                  <h4 class="name">All Case Types</h4>
                  <p>
                    {{
                      patientSettingsInfo.email_sending_data.for_all_case_types
                        ? "Yes"
                        : "No"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :span="14">
                <div
                  class="input-value view-cases"
                  v-if="
                    patientSettingsInfo &&
                    patientSettingsInfo.email_sending_data &&
                    patientSettingsInfo.email_sending_data
                      .for_specific_case_types &&
                    patientSettingsInfo.email_sending_data
                      .for_specific_case_types.length
                  "
                >
                  <h4 class="name">Specific Case Types</h4>
                  <ul>
                    <li
                      v-for="(caseType, index) in patientSettingsInfo
                        .email_sending_data.for_specific_case_types"
                      :key="index"
                    >
                      {{ caseTypeMap[caseType] }}
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="5">
                <div
                  class="input-value"
                  v-if="
                    patientSettingsInfo && patientSettingsInfo.sms_sending_data
                  "
                >
                  <h4 class="name">SMS Sending</h4>
                  <p>
                    {{
                      patientSettingsInfo.sms_sending_data.status ? "Yes" : "No"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :span="5">
                <div
                  class="input-value"
                  v-if="
                    patientSettingsInfo && patientSettingsInfo.sms_sending_data
                  "
                >
                  <h4 class="name">All Case Types</h4>
                  <p>
                    {{
                      patientSettingsInfo.sms_sending_data.for_all_case_types
                        ? "Yes"
                        : "No"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :span="14">
                <div
                  class="input-value view-cases"
                  v-if="
                    patientSettingsInfo &&
                    patientSettingsInfo.sms_sending_data &&
                    patientSettingsInfo.sms_sending_data
                      .for_specific_case_types &&
                    patientSettingsInfo.sms_sending_data.for_specific_case_types
                      .length
                  "
                >
                  <h4 class="name">Specific Case Types</h4>
                  <ul>
                    <li
                      v-for="(caseType, index) in patientSettingsInfo
                        .sms_sending_data.for_specific_case_types"
                      :key="index"
                    >
                      {{ caseTypeMap[caseType] }}
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div
        class="case-creation__card mt-10"
        v-if="getSingleHospital && status == 'edit'"
      >
        <div class="vue-data">
          <div class="case-creation__body pb-0">
            <el-form
              :model="hospitalInfo"
              class="vue-form"
              :disabled="isLabdaqOnlyEditor"
            >
              <el-row :gutter="20">
                <el-col :xl="5" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">
                        Ordering Facility Name
                        <span class="star">*</span>
                      </label>

                      <el-input
                        placeholder="Enter Ordering Facility Name"
                        v-model="hospitalInfo.name"
                        class="el-input convert-upper"
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getHospitalValidationErrors &&
                          getHospitalValidationErrors.name
                        "
                      >
                        {{ getHospitalValidationErrors.name }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :xl="2" :lg="2" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        Code
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Enter Code"
                        v-model="hospitalInfo.code"
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getHospitalValidationErrors &&
                          getHospitalValidationErrors.code
                        "
                      >
                        {{ getHospitalValidationErrors.code }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        Phone Number
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Enter Phone Number"
                        v-model="hospitalInfo.phone"
                        maxlength="10"
                        
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getHospitalValidationErrors &&
                          getHospitalValidationErrors.phone
                        "
                      >
                        {{ getHospitalValidationErrors.phone }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :xl="5" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text"> Email </label>
                      <el-input
                        class="email-lower"
                        type="email"
                        placeholder="Enter Email"
                        v-model="hospitalInfo.email"
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getHospitalValidationErrors &&
                          getHospitalValidationErrors.email
                        "
                      >
                        {{ getHospitalValidationErrors.email }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text"> Fax </label>
                      <el-input
                        maxlength="10"
                        placeholder="Enter Fax"
                        v-model="hospitalInfo.fax"
                        
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getHospitalValidationErrors &&
                          getHospitalValidationErrors.fax
                        "
                      >
                        {{ getHospitalValidationErrors.fax }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">Address Line 1</label>
                      <el-input
                        placeholder="Enter Address Line 1"
                        v-model="hospitalInfo.address_line_1"
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getHospitalValidationErrors &&
                          getHospitalValidationErrors.address_line_1
                        "
                      >
                        {{ getHospitalValidationErrors.address_line_1 }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="5" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">Address Line 2</label>
                      <el-input
                        placeholder="Enter Address Line 2"
                        v-model="hospitalInfo.address_line_2"
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getHospitalValidationErrors &&
                          getHospitalValidationErrors.address_line_2
                        "
                      >
                        {{ getHospitalValidationErrors.address_line_2 }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="2" :lg="2" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        Zip
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Enter Zip"
                        v-model="hospitalInfo.zip"
                        maxlength="5"
                        @input="getStateCity"
                        
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getHospitalValidationErrors &&
                          getHospitalValidationErrors.zip
                        "
                      >
                        {{ getHospitalValidationErrors.zip }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <state
                        :stateData="hospitalInfo"
                        :validataionErrors="getHospitalValidationErrors"
                        :errorKey="'state'"
                      ></state>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="5" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <city
                        :cityData="hospitalInfo"
                        :validataionErrors="getHospitalValidationErrors"
                        :errorKey="'city'"
                      ></city>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text"
                        >NPI
                        <span class="star">*</span>
                      </label>
                      <el-input v-model="hospitalInfo.npi"></el-input>
                      <p
                        class="err"
                        v-if="
                          getHospitalValidationErrors &&
                          getHospitalValidationErrors.npi
                        "
                      >
                        {{ getHospitalValidationErrors.npi }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text"
                        >Sales Rep <span class="star"> *</span></label
                      >
                      <el-select
                        v-model="hospitalInfo.facility_marketer"
                        placeholder="Select Sales Rep"
                        default-first-option
                        :reserve-keyword="false"
                        filterable
                        clearable
                      >
                        <el-option
                          v-for="(user, index) in marketerData"
                          :key="index"
                          :label="user.first_name + ' ' + user.last_name"
                          :value="user._id"
                        >
                        </el-option>
                      </el-select>
                      <p class="err error-break">
                        <FormError errorName="facility_marketer"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text"
                        >Account Manager <span class="star"> *</span></label
                      >
                      <el-select
                        v-model="hospitalInfo.account_managers"
                        placeholder="Select account manager"
                        default-first-option
                        :reserve-keyword="false"
                        filterable
                        clearable
                        multiple
                        collapse-tags
                      >
                        <el-option
                          v-for="(user, index) in accountManagerData"
                          :key="index"
                          :label="user.first_name + ' ' + user.last_name"
                          :value="user._id"
                        >
                        </el-option>
                      </el-select>
                      <p class="err error-break">
                        <FormError errorName="account_managers"></FormError>
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
            <el-form :model="hospitalInfo" class="vue-form">
              <el-row :gutter="20">
                <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">Labdaq Code</label>
                      <el-input v-model="hospitalInfo.labdaq_code"></el-input>
                      <p
                        class="err"
                        v-if="
                          getHospitalValidationErrors &&
                          getHospitalValidationErrors.labdaq_code
                        "
                      >
                        {{ getHospitalValidationErrors.labdaq_code }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="case-creation__card mt-10">
            <div class="case-creation__heading">
              <div class="title-with-icon">
                <span class="icon">
                  <img
                    src="@/assets/images/icons/icon-patient-info.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                </span>
                <h3 class="title">CONTACT INFORMATION</h3>
              </div>
            </div>
            <div class="case-creation__body pb-0">
              <div class="vue-form">
                <el-form :model="hospitalInfo" :disabled="isLabdaqOnlyEditor">
                  <!-- Critical Reporting Point of Contact -->
                  <div class="contact-section mb-20">
                    <h4 class="contact-section-title">Critical Reporting Point of Contact</h4>
                    <el-row :gutter="20">
                      <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                        <div class="case-creation__input">
                          <el-form-item class="mb-15">
                            <label for="text">Name</label>
                            <el-input
                              v-model="hospitalInfo.contact_poc.name"
                              placeholder="Enter Name"
                              class="el-input convert-upper"
                            ></el-input>
                            <p class="err">
                              <FormError errorName="contact_poc.name"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                        <div class="case-creation__input">
                          <el-form-item class="mb-15">
                            <label for="text">Email</label>
                            <el-input
                              v-model="hospitalInfo.contact_poc.email"
                              placeholder="Enter Email"
                            ></el-input>
                            <p class="err">
                              <FormError errorName="contact_poc.email"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                        <div class="case-creation__input">
                          <el-form-item class="mb-15">
                            <label for="text">Phone Number</label>
                            <el-input
                              maxlength="10"
                              v-model="hospitalInfo.contact_poc.phone_number"
                              placeholder="Enter Phone Number"
                            ></el-input>
                            <p class="err">
                              <FormError errorName="contact_poc.phone_number"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                  </div>

                  <!-- Rejections and Recollections Point of Contact -->
                  <div class="contact-section">
                    <h4 class="contact-section-title">Rejections and Recollections Point of Contact</h4>
                    <el-row :gutter="20">
                      <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                        <div class="case-creation__input">
                          <el-form-item class="mb-15">
                            <label for="text">Name</label>
                            <el-input
                              v-model="hospitalInfo.rejection_poc.name"
                              placeholder="Enter Name"
                              class="el-input convert-upper"
                            ></el-input>
                            <p class="err">
                              <FormError errorName="rejection_poc.name"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                        <div class="case-creation__input">
                          <el-form-item class="mb-15">
                            <label for="text">Email</label>
                            <el-input
                              v-model="hospitalInfo.rejection_poc.email"
                              placeholder="Enter Email"
                            ></el-input>
                            <p class="err">
                              <FormError errorName="rejection_poc.email"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                        <div class="case-creation__input">
                          <el-form-item class="mb-15">
                            <label for="text">Phone Number</label>
                            <el-input
                              maxlength="10"
                              v-model="hospitalInfo.rejection_poc.phone_number"
                              placeholder="Enter Phone Number"
                            ></el-input>
                            <p class="err">
                              <FormError errorName="rejection_poc.phone_number"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
          <div class="hospitals-settings">
            <div class="case-creation__heading border-top">
              <div class="title-with-icon">
                <span class="icon">
                  <img
                    src="@/assets/images/icons/icon-case-info.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                </span>
                <h3 class="title">Ordering Facility Settings</h3>
              </div>
            </div>
            <div class="case-creation__body pb-0">
              <div class="radio-buttons-alignments">
                <el-form :disabled="isLabdaqOnlyEditor">
                  <el-row>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for=""
                          >Auto Fax <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio
                              v-model="form.auto_fax"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.auto_fax"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for=""
                          >Email Notifications
                          <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio
                              v-model="form.email_notifications"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.email_notifications"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for="">Requires Inhouse Phlebotomist</label>
                        <el-form-item class="text mb-0">
                          <div class="d-flex">
                            <el-radio
                              v-model="form.requires_inhouse_phlebotomist"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.requires_inhouse_phlebotomist"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for=""
                          >Daily Statistics <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio
                              v-model="form.daily_statistics"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.daily_statistics"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <el-form :disabled="false">
                        <div class="case-creation__input">
                          <label for=""
>Is Labdaq <span class="star">*</span></label
                          >
                          <el-form-item class="text mb-0" :required="true">
                            <div class="d-flex">
                              <el-radio
                                v-model="form.is_labdaq"
                                :value="true"
                                :label="true"
                                >Yes</el-radio
                              >
                              <el-radio
                                v-model="form.is_labdaq"
                                :value="false"
                                :label="false"
                                >No</el-radio
                              >
                            </div>
                          </el-form-item>
                        </div>
                      </el-form>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for=""
                          >Uni Direction EMR <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio
                              v-model="form.emr_unidirectional_status"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.emr_unidirectional_status"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col
                      :span="6"
                      v-if="hasPermission('notify_rejection', 'add')"
                    >
                      <div class="case-creation__input">
                        <label for=""
                          >Restrict Insurance <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio
                              v-model="form.restrict_insurance"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.restrict_insurance"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col
                      :span="6"
                      v-if="hasPermission('notify_rejection', 'add')"
                    >
                      <div class="case-creation__input">
                        <label for=""
                          >Notify Rejections <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio
                              v-model="form.notify_rejections"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.notify_rejections"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col
                      :span="6"
                      v-if="hasPermission('notify_rejection', 'add')"
                    >
                      <div class="case-creation__input">
                        <label for=""
                          >Release <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio
                              v-model="form.release_note"
                              :value="true"
                              :label="true"
                              >Yes</el-radio
                            >
                            <el-radio
                              v-model="form.release_note"
                              :value="false"
                              :label="false"
                              >No</el-radio
                            >
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for="">Sample Collection Type <span class="star">*</span></label>
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio v-model="form.sample_collection_type" value="HOME" label="HOME">Home</el-radio>
                            <el-radio v-model="form.sample_collection_type" value="INCLINIC" label="INCLINIC">In Clinic</el-radio>
                            <el-radio v-model="form.sample_collection_type" value="BOTH" label="BOTH">Both</el-radio>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for="">Daily Sample Pickup <span class="star">*</span></label>
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio v-model="form.is_daily_sample_pickup" :value="true" :label="true">Yes</el-radio>
                            <el-radio v-model="form.is_daily_sample_pickup" :value="false" :label="false">No</el-radio>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row v-if="form.is_daily_sample_pickup">
                    <el-col :span="12">
                      <div class="case-creation__input">
                        <label for="">Pickup Days</label>
                        <el-checkbox-group v-model="form.pickup_days" style="display: flex; flex-wrap: wrap; gap: 10px;">
                          <el-checkbox
                            v-for="day in ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']"
                            :key="day"
                            :label="day"
                          >{{ day }}</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for="">Pickup Time</label>
                        <el-input
                          v-model="form.pickup_time"
                          placeholder="Enter pickup time (e.g. 09:00 AM)"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row v-if="form.is_daily_sample_pickup">
                    <el-col :span="24">
                      <div class="case-creation__input d-flex" style="justify-content: space-between; align-items: center;">
                        <label for="">Pickup Address</label>
                        <el-button type="text" @click="fillPickupAddressFromFacility">Same as Facility Address</el-button>
                      </div>
                      <el-input
                        v-model="form.pickup_address"
                        placeholder="Enter pickup address"
                      ></el-input>
                    </el-col>
                  </el-row>
                  <el-row v-if="form.is_daily_sample_pickup">
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for="">Pickup Zip</label>
                        <el-input v-model="form.pickup_zip" maxlength="5" placeholder="Zip"></el-input>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for="">Pickup City</label>
                        <el-input v-model="form.pickup_city" placeholder="City"></el-input>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="case-creation__input">
                        <label for="">Pickup State</label>
                        <el-input v-model="form.pickup_state" placeholder="State"></el-input>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>

              <p class="err">
                <FormError errorName="critical_error"></FormError>
              </p>
            </div>
          </div>
          <div class="hospitals-settings">
            <div class="case-creation__heading border-top">
              <div class="title-with-icon">
                <span class="icon">
                  <img
                    src="@/assets/images/icons/icon-case-info.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                </span>
                <h3 class="title">Patient Report Settings</h3>
              </div>
            </div>
            <div class="case-creation__body pb-0">
              <div class="radio-buttons-alignments">
                <el-form :disabled="isLabdaqOnlyEditor">
                  <el-row>
                    <el-col :span="8">
                      <div class="case-creation__input">
                        <label for=""
                          >Send Finalized Report To Patient
                          <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio-group
                              v-model="form.send_finalized_report_to_patient"
                              @change="resetSettings"
                            >
                              <el-radio :value="true" :label="true"
                                >Yes</el-radio
                              >
                              <el-radio :value="false" :label="false"
                                >No</el-radio
                              >
                            </el-radio-group>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row v-if="form.send_finalized_report_to_patient === true">
                    <el-col :span="8">
                      <div class="case-creation__input">
                        <label for=""
                          >Email Sending <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio-group v-model="form.email_sending">
                              <el-radio :value="true" :label="true"
                                >Yes</el-radio
                              >
                              <el-radio :value="false" :label="false"
                                >No</el-radio
                              >
                            </el-radio-group>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8" v-if="form.email_sending === true">
                      <div class="case-creation__input">
                        <label for=""
                          >All Case Types <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio-group
                              v-model="form.for_all_case_types"
                              @change="clearEmailCaseTypes"
                            >
                              <el-radio :value="true" :label="true"
                                >Yes</el-radio
                              >
                              <el-radio :value="false" :label="false"
                                >No</el-radio
                              >
                            </el-radio-group>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col
                      :span="8"
                      v-if="
                        form.for_all_case_types === false &&
                        form.email_sending === true
                      "
                    >
                      <div class="case-creation__input">
                        <label for=""
                          >Select Case Types <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-select
                              multiple
                              filterable
                              v-model="form.case_types"
                              placeholder="Select Case type"
                              collapse-tags
                            >
                              <el-option
                                v-for="(
                                  caseType, index
                                ) of this.getLabBasedCaseTypes(caseTyeData)"
                                :key="index"
                                :value="caseType.value"
                                :label="caseType.case_name"
                              ></el-option>
                            </el-select>
                          </div>
                          <p class="err">
                            <FormError
                              errorName="settings.patient_report_settings.email_sending_data.for_specific_case_types"
                            ></FormError>
                          </p>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row v-if="form.send_finalized_report_to_patient === true">
                    <el-col :span="8">
                      <div class="case-creation__input">
                        <label for=""
                          >SMS Sending <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio-group v-model="form.sms_sending">
                              <el-radio :value="true" :label="true"
                                >Yes</el-radio
                              >
                              <el-radio :value="false" :label="false"
                                >No</el-radio
                              >
                            </el-radio-group>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="8" v-if="form.sms_sending === true">
                      <div class="case-creation__input">
                        <label for=""
                          >All Case Types <span class="star">*</span></label
                        >
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-radio-group
                              v-model="form.sms_for_all_case_types"
                              @change="clearSMSCaseTypes"
                            >
                              <el-radio :value="true" :label="true"
                                >Yes</el-radio
                              >
                              <el-radio :value="false" :label="false"
                                >No</el-radio
                              >
                            </el-radio-group>
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col
                      :span="8"
                      v-if="
                        form.sms_for_all_case_types === false &&
                        form.sms_sending === true
                      "
                    >
                      <div class="case-creation__input">
                        <label for=""
                          >Select Case Types <span class="star">*</span>
                        </label>
                        <el-form-item class="text mb-0" :required="true">
                          <div class="d-flex">
                            <el-select
                              multiple
                              filterable
                              v-model="form.sms_case_types"
                              placeholder="Select Case type"
                              collapse-tags
                            >
                              <el-option
                                v-for="(
                                  caseType, index
                                ) of this.getLabBasedCaseTypes(caseTyeData)"
                                :key="index"
                                :value="caseType.value"
                                :label="caseType.case_name"
                              ></el-option>
                            </el-select>
                          </div>
                          <p class="err">
                            <FormError
                              errorName="settings.patient_report_settings.sms_sending_data.for_specific_case_types"
                            ></FormError>
                          </p>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>

              <p class="err">
                <FormError errorName="critical_error"></FormError>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="case-creation__actions"
        v-if="getSingleHospital && status == 'edit'"
      >
        <ul class="list">
          <li>
            <el-button
              type="button"
              class="btn cancel-button"
              @click="cancelHospitalDetails"
            >
              Cancel
            </el-button>
          </li>
          <li v-if="this.$route.params && this.$route.params.hospital_id">
            <el-button
              type="success"
              class="btn save-button"
              @click="submitHospitalDetails"
              :disabled="disableSubmitButton"
              >Update</el-button
            >
          </li>
          <li v-else>
            <el-button
              type="button"
              class="btn save-button"
              @click="submitHospitalDetails"
              :disabled="disableSubmitButton"
              >Save</el-button
            >
          </li>
        </ul>
      </div>
    </div>
    <AuditLogs
      v-if="AuditLogsPopup"
      :hospitalId="hospital_id"
      v-on:close="AuditLogsPopup = false"
    ></AuditLogs>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import caseDataHelper from "@/mixins/caseDataHelper";
const state = defineAsyncComponent(() => import("@/components/misc/State"));
const city = defineAsyncComponent(() => import("@/components/misc/City"));
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
import AuditLogs from "@/components/cases/AllLogs";
import caseConstants from "@/config/constants/caseConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";

import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      loading: false,
      hospitalInfo: {},
      settingsInfo: {},
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseTyeData: caseConstants.CASE_TYPES_DATA,
      patientSettingsInfo: {},
      form: {
        auto_fax: false,
        email_notifications: false,
        requires_inhouse_phlebotomist: false,
        daily_statistics: false,
        send_finalized_report_to_patient: false,
        case_types: [],
        sms_case_types: [],
        for_all_case_types: true,
        sms_for_all_case_types: true,
        email_sending: false,
        sms_sending: false,
        reporting_settings: [],
        is_labdaq: false,
        emr_unidirectional_status: false,
        restrict_insurance: false,
        notify_rejections: false,
        release_note: false,
        sample_collection_type: "",
        is_daily_sample_pickup: false,
        pickup_time: "",
        pickup_days: [],
        pickup_address: "",
        pickup_zip: "",
        pickup_city: "",
        pickup_state: "",
      },
      status: "view",
      disableSubmitButton: false,
      marketerData: [],
      selectedFile: null,
      selectedFileName: null,
      accountManagerData: [],
      AuditLogsPopup: false,
    };
  },
  mixins: [caseDataHelper, UserPermissionsHelper],
  components: {
    state,
    city,
    FormError,
    AuditLogs,
  },
  computed: {
    ...mapGetters("hospitals", [
      "getHospitalAddStatus",
      "getHospitalValidationErrors",
      "getSingleHospital",
      "getRemoveConsentFormStatus",
      "getUpdateConsentFormStatus",
      "getFileUploadURLForAttachments",
      "getUplodConsentFormStatus",
    ]),
    ...mapGetters("cases", [
      "getStateAndCity",
      "getAttachmentUploadStatusForAttachments",
    ]),
    hospital_id() {
      if (this.$route.params.hospital_id) {
        return this.$route.params.hospital_id;
      }
      return null;
    },
    ...mapGetters("userAccounts", ["getAllUsers"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    isLabdaqOnlyEditor() {
      const allowed = ["sathwiks", "leslie", "viveka"];
      const username =
        this.getAuthenticatedUser && this.getAuthenticatedUser.username
          ? this.getAuthenticatedUser.username.toLowerCase()
          : "";
      return allowed.includes(username);
    },
  },
  async mounted() {
    await this.fetchHospitalDetails(this.hospital_id);
    this.$store.dispatch("hospitals/clearValidationErrors");
    this.$store.dispatch("help/fetchAllStates");
    await this.fetchAllUsers();
  },
  methods: {
    viewHospitalAudit() {
      this.AuditLogsPopup = true;
    },
    remove() {
      (this.selectedFile = null), (this.selectedFileName = "");
    },
    uploadFile(file) {
      if (!file.raw.type.includes("pdf")) {
        this.$message.error("Only PDF files are allowed.");
        return;
      }
      this.selectedFile = file.raw;
      this.selectedFileName = file.raw.name;
      this.getFileUploadUrl(file);
    },
    async getFileUploadUrl(file) {
      try {
        this.disableSubmitButton = true;
        let data = {
          file: file.raw.name,
          file_type: file.raw.type,
          file_size: file.raw.size / 1000,
        };
        await this.$store.dispatch("hospitals/fetchDocumentUploadUrl", data);
        if (this.getUplodConsentFormStatus) {
          let params = {
            file: this.selectedFile,
            upload_url: this.getFileUploadURLForAttachments.target_url,
          };
          await this.$store.dispatch(
            "cases/uploadDocumentToGeneratedUrlForAttachments",
            params
          );
          if (this.getAttachmentUploadStatusForAttachments) {
            let params = {
              hospital_id: this.hospital_id,
              name: this.getFileUploadURLForAttachments.path,
              path: this.getFileUploadURLForAttachments.path,
              metadata: this.getFileUploadURLForAttachments.data.metadata,
            };
            await this.$store.dispatch("hospitals/updateConsentForm", params);
            if (this.getUpdateConsentFormStatus) {
              successNotification("Account setup form uploaded successfully");
              this.remove();
              await this.fetchHospitalDetails(this.hospital_id);
            } else {
              errorNotification("Error while uploading account setup form");
            }
          } else {
            errorNotification("Error while uploading account setup form");
          }
        } else {
          errorNotification("Error while uploading account setup form");
        }
        this.disableSubmitButton = false;
      } catch (error) {
        console.log(error);
        this.disableSubmitButton = false;
      } finally {
        this.disableSubmitButton = false;
      }
    },
    async removeFacilityConsentForm(path) {
      this.$confirm("Are you sure to remove Account Setup Form?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.removeFacilityConsent(path);
      });
    },
    async removeFacilityConsent(path) {
      try {
        this.disableSubmitButton = true;
        let params = {
          hospital_id: this.hospital_id,
          path: path,
        };
        await this.$store.dispatch("hospitals/removeConsentForm", params);
        if (this.getRemoveConsentFormStatus) {
          successNotification("Account setup form removed successfully");
          await this.fetchHospitalDetails(this.hospital_id);
        } else {
          errorNotification("Error while removing account setup form");
        }
        this.disableSubmitButton = false;
      } catch (err) {
        this.disableSubmitButton = false;
        console.log(err);
      } finally {
        this.disableSubmitButton = false;
      }
    },
    async downloadAttachment(doc) {
      let attachment_type = "facilities_attachments";
      let routerData = this.$router.resolve({
        name: "ViewAttachments",
        params: {
          path: doc.path,
        },
        query: { attachment_type: attachment_type },
      });
      window.open(routerData.href, "_blank");
    },
    async fetchAllUsers() {
      await this.$store.dispatch("userAccounts/fetchAllUserAccounts", {
        get_all: true,
        order_by: "first_name",
        order_type: "asc",
        user_types: [
          "MARKETER",
          "HOSPITAL_MARKETING_MANAGER",
          "SALES_DIRECTOR",
          "REGIONAL_DIRECTOR",
          "ACCOUNT_MANAGER",
        ],
        status:"ACTIVE"
      });
      if (this.getAllUsers && this.getAllUsers.data) {
        let accountUser = [
          "MARKETER",
          "HOSPITAL_MARKETING_MANAGER",
          "SALES_DIRECTOR",
          "REGIONAL_DIRECTOR",
        ];
        this.marketerData = this.getAllUsers.data.filter((item) =>
          accountUser.includes(item.user_type)
        );
      }
      let accountUser = ["ACCOUNT_MANAGER"];
      this.accountManagerData = this.getAllUsers.data.filter((item) =>
        accountUser.includes(item.user_type)
      );
    },
    resetSettings() {
      this.form.email_sending = false;
      this.form.case_types = [];
      this.form.for_all_case_types = true;
      this.form.sms_sending = false;
      this.form.sms_case_types = [];
      this.form.sms_for_all_case_types = true;
    },
    clearEmailCaseTypes() {
      this.form.case_types = [];
    },
    clearSMSCaseTypes() {
      this.form.sms_case_types = [];
    },
    async getStateCity() {
      try {
        let params = {
          zip: this.hospitalInfo.zip,
        };
        await this.$store.dispatch("cases/getStateCity", params);
        if (this.getStateAndCity) {
          this.hospitalInfo.state = this.getStateAndCity.state;
          this.hospitalInfo.city = this.getStateAndCity.city;
        } else {
          if (!this.getStateAndCity && params.zip.length == 5) {
            this.$message({
              message: "No State & City Found",
              type: "warning",
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async fetchHospitalDetails(hospital_id) {
      this.loading = true;
      await this.$store.dispatch("hospitals/fetchSingleHospital", hospital_id);
      this.loading = false;
      this.hospitalInfo = JSON.parse(JSON.stringify(this.getSingleHospital));
      
      // Initialize contact_poc and rejection_poc if they don't exist
      if (!this.hospitalInfo.contact_poc) {
        this.hospitalInfo.contact_poc = {
          name: "",
          email: "",
          phone_number: "",
        };
      }
      if (!this.hospitalInfo.rejection_poc) {
        this.hospitalInfo.rejection_poc = {
          name: "",
          email: "",
          phone_number: "",
        };
      }
      
      if (this.getSingleHospital && this.getSingleHospital.settings) {
        this.settingsInfo = JSON.parse(
          JSON.stringify(this.getSingleHospital.settings)
        );
      }
      if (
        this.getSingleHospital &&
        this.getSingleHospital.settings &&
        this.getSingleHospital.settings.patient_report_settings
      ) {
        this.patientSettingsInfo = JSON.parse(
          JSON.stringify(
            this.getSingleHospital.settings.patient_report_settings
          )
        );
      }

      this.settingsInfo.daily_statistics =
        this.settingsInfo.daily_statistics || false;
      this.settingsInfo.is_labdaq = this.settingsInfo.is_labdaq || false;
      this.settingsInfo.emr_unidirectional_status =
        this.settingsInfo.emr_unidirectional_status || false;
      this.settingsInfo.restrict_insurance =
        this.settingsInfo.restrict_insurance || false;
      this.form.auto_fax = this.settingsInfo.auto_fax || false;
      this.form.email_notifications =
        this.settingsInfo.email_notifications || false;
      this.form.requires_inhouse_phlebotomist =
        this.settingsInfo.requires_inhouse_phlebotomist || false;
      this.form.daily_statistics = this.settingsInfo.daily_statistics || false;
      this.form.is_labdaq = this.settingsInfo.is_labdaq || false;
      this.form.emr_unidirectional_status =
        this.settingsInfo.emr_unidirectional_status || false;
      this.form.restrict_insurance =
        this.settingsInfo.restrict_insurance || false;
      this.form.notify_rejections =
        this.settingsInfo.notify_rejections || false;
      this.form.release_note = this.settingsInfo.release_note || false;
      this.form.sample_collection_type =
        this.settingsInfo.sample_collection_type || "";
      this.form.is_daily_sample_pickup =
        this.settingsInfo.is_daily_sample_pickup || false;
      this.form.pickup_time = this.settingsInfo.pickup_time || "";
      this.form.pickup_days = this.settingsInfo.pickup_days || [];
      this.form.pickup_address = this.settingsInfo.pickup_address || "";
      this.form.pickup_zip = this.settingsInfo.pickup_zip || "";
      this.form.pickup_city = this.settingsInfo.pickup_city || "";
      this.form.pickup_state = this.settingsInfo.pickup_state || "";
      if (
        this.getSingleHospital &&
        this.getSingleHospital.settings &&
        this.getSingleHospital.settings.patient_report_settings &&
        this.getSingleHospital.settings.patient_report_settings
          .email_sending_data
      ) {
        this.form.email_sending =
          this.patientSettingsInfo.email_sending_data.status || false;
        this.form.for_all_case_types =
          this.patientSettingsInfo.email_sending_data.for_all_case_types;
        this.form.case_types =
          this.patientSettingsInfo.email_sending_data.for_specific_case_types ||
          [];
      }
      this.form.send_finalized_report_to_patient =
        this.patientSettingsInfo.send_finalized_report_to_patient || false;
      if (
        this.getSingleHospital &&
        this.getSingleHospital.settings &&
        this.getSingleHospital.settings.patient_report_settings &&
        this.getSingleHospital.settings.patient_report_settings.sms_sending_data
      ) {
        this.form.sms_sending =
          this.patientSettingsInfo.sms_sending_data.status || false;
        this.form.sms_for_all_case_types =
          this.patientSettingsInfo.sms_sending_data.for_all_case_types;
        this.form.sms_case_types =
          this.patientSettingsInfo.sms_sending_data.for_specific_case_types ||
          [];
      }
      if (
        this.getSingleHospital &&
        this.getSingleHospital.settings &&
        this.getSingleHospital.settings.reporting_settings &&
        this.getSingleHospital.settings.reporting_settings.length
      ) {
        this.form.reporting_settings =
          this.getSingleHospital.settings.reporting_settings;
      }
    },

    async changeStatus() {
      await this.fetchAllUsers();
      if (this.getSingleHospital && this.getSingleHospital.facility_marketer) {
        const marketer = this.getSingleHospital.facility_marketer[0];
        if (marketer) {
          this.hospitalInfo.facility_marketer = marketer._id;
        } else {
          this.hospitalInfo.facility_marketer = [];
        }
      } else {
        this.hospitalInfo.facility_marketer = [];
      }
      if (this.getSingleHospital && this.getSingleHospital.account_managers) {
        const marketer = this.getSingleHospital.account_managers;
        if (marketer) {
          this.hospitalInfo.account_managers = marketer.map((e) => e._id);
        } else {
          this.hospitalInfo.account_managers = [];
        }
      } else {
        this.hospitalInfo.account_managers = [];
      }
      // Ensure contact_poc and rejection_poc are initialized
      if (!this.hospitalInfo.contact_poc) {
        this.hospitalInfo.contact_poc = {
          name: "",
          email: "",
          phone_number: "",
        };
      }
      if (!this.hospitalInfo.rejection_poc) {
        this.hospitalInfo.rejection_poc = {
          name: "",
          email: "",
          phone_number: "",
        };
      }
      this.status = "edit";
      this.$store.dispatch("hospitals/clearValidationErrors");
    },
    formatCollectionType(value) {
      if (value === "HOME") return "Home";
      if (value === "INCLINIC") return "In Clinic";
      if (value === "BOTH") return "Both";
      return "--";
    },
    fillPickupAddressFromFacility() {
      this.form.pickup_address = this.hospitalInfo.address_line_1 || "";
      this.form.pickup_zip = this.hospitalInfo.zip || "";
      this.form.pickup_city = this.hospitalInfo.city || "";
      this.form.pickup_state = this.hospitalInfo.state || "";
    },
    prepareHospitalAddData() {
      if (this.hospital_id) {
        this.hospitalInfo.id = this.hospital_id;
      }
      if (this.hospitalInfo.email) {
        this.hospitalInfo.email = this.hospitalInfo.email.toLowerCase();
      }
      if (this.hospitalInfo.name) {
        this.hospitalInfo.name = this.hospitalInfo.name.toUpperCase();
      }
      return this.hospitalInfo;
    },
    async submitHospitalDetails() {
      this.disableSubmitButton = true;

      const payload = this.prepareHospitalAddData();
      payload.settings = {
        daily_statistics: this.form.daily_statistics || false,
        auto_fax: this.form.auto_fax || false,
        email_notifications: this.form.email_notifications || false,
        requires_inhouse_phlebotomist:
          this.form.requires_inhouse_phlebotomist || false,
        patient_report_settings: {
          send_finalized_report_to_patient:
            this.form.send_finalized_report_to_patient || false,
          sms_sending_data: {
            for_specific_case_types: this.form.sms_case_types || [],
            status: this.form.sms_sending || false,
            for_all_case_types: this.form.sms_for_all_case_types,
          },
          email_sending_data: {
            for_specific_case_types: this.form.case_types || [],
            status: this.form.email_sending || false,
            for_all_case_types: this.form.for_all_case_types,
          },
        },
        reporting_settings: this.form.reporting_settings || [],
        is_labdaq: this.form.is_labdaq || false,
        emr_unidirectional_status: this.form.emr_unidirectional_status || false,
        restrict_insurance: this.form.restrict_insurance || false,
        notify_rejections: this.form.notify_rejections || false,
        release_note: this.form.release_note || false,
        sample_collection_type: this.form.sample_collection_type || "",
        is_daily_sample_pickup: this.form.is_daily_sample_pickup || false,
        pickup_time: this.form.pickup_time || "",
        pickup_days: this.form.pickup_days || [],
        pickup_address: this.form.pickup_address || "",
        pickup_zip: this.form.pickup_zip || "",
        pickup_city: this.form.pickup_city || "",
        pickup_state: this.form.pickup_state || "",
      };
    const originalFacilityMarketer = this.hospitalInfo.facility_marketer;
    const originalAccountManagers = this.hospitalInfo.account_managers;

     payload.facility_marketer = originalFacilityMarketer
       ? [originalFacilityMarketer]
        : [];
     payload.account_managers = originalAccountManagers
       ? originalAccountManagers
      : [];

      if (!payload.address_line_2) delete payload.address_line_2;
      await this.$store.dispatch("hospitals/editHospital", payload);
      this.disableSubmitButton = false;

      this.hospitalInfo.facility_marketer = originalFacilityMarketer;
      this.hospitalInfo.account_managers = originalAccountManagers;
      if (this.getHospitalAddStatus && this.getHospitalAddStatus.success) {
        successNotification(this.getHospitalAddStatus.message);

        this.status = "view";
        await this.fetchHospitalDetails(this.hospital_id);
      } else if (this.getHospitalValidationErrors) {
        this.scrollToFirstError();
      } else if (this.getHospitalValidationErrors.critical_error) {
        errorNotification(this.getHospitalValidationErrors.critical_error);
      }
    },
    scrollToFirstError() {
      let el = this.$el.getElementsByClassName("error")[0];
      if (el) {
        el.scrollIntoView({ block: "center" });
      }
    },
    cancelHospitalDetails() {
      if (Object.keys(this.hospitalInfo).length === 0) {
        this.clearDataAndGoToHospitals();
      } else {
        this.$confirm(
          "Are you sure to cancel Update Ordering Facility?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        ).then(() => {
          this.clearDataAndGoToHospitals();
        });
      }
    },
    clearDataAndGoToHospitals() {
      // Resetting hospital data to previous data
      this.hospitalInfo = JSON.parse(JSON.stringify(this.getSingleHospital));
      this.goToHospitals();
    },
    goToHospitals() {
      this.status = "view";
    },
  },
};
</script>

<style lang="scss">
#hospital-primary-information {
  .radio-buttons-alignments {
    .el-radio__input .el-radio__inner {
      border-color: transparent;
      box-shadow: 0 0 0 1px #ced1d6;
    }
    .el-radio__input.is-checked .el-radio__inner {
      background-color: #0a5da6;
      border-color: #ffffff;
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #0a5da6;
    }
    .case-creation__input .el-form-item {
      margin-top: 10px;
      margin-bottom: 0px !important;
    }
  }
  .border-top {
    border-top: 1.2px solid #e7e7f7;
  }
  .hospitals-settings {
    .el-select {
      max-width: 300px;
    }
    .el-radio-group {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .contact-section {
    margin-bottom: 20px;
    .contact-section-title {
      font-size: 14px;
      font-weight: 600;
      color: #1b2459;
      margin-bottom: 15px;
    }
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .vue-data {
    position: relative;
  }
  .hospital-action-buttons {
    position: absolute;
    top: 15px;
    right: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    z-index: 9;
  }
  .hospital-edit-btn {
    padding: 0 14px;
    height: 30px;
    min-height: 30px;
    border: none;
    background-color: transparent;
    color: #828282;
    .edit-icon {
      display: flex;
      align-items: center;
      gap: 4px;
      img {
        width: 15px;
        height: 15px;
      }
    }
    &:hover,
    &:focus {
      background-color: transparent;
      color: #828282;
    }
  }
  .audit-btn {
    padding: 0 6px;
    height: 30px;
    min-height: 30px;
    border: 1px solid #273480;
    color: #273480;
    background-color: transparent;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    &:hover,
    &:focus {
      background-color: #273480;
      color: #ffffff;
    }
  }
}
</style>
